export function isValidEmailAddress(input) {
  const inputString = String(input);
  // eslint-disable-next-line no-useless-escape
  const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,63}$/);
  if (!inputString) return false;
  return regex.test(inputString);
}
